import { Injectable, OnDestroy } from '@angular/core';
import { SecurityRole } from '@jms/model';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class PermissionService implements OnDestroy {

  private role: SecurityRole;

  constructor() { }
  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  public setRole(role$: Observable<SecurityRole>) {

    role$.pipe(
      untilDestroyed(this)
    ).subscribe(x => {
      this.role = x;
    });
  }

  public getRole() {
    return this.role;
  }


}
